import { useEffect, useState } from 'react'; //useContext,
import { AddressApiInterface } from 'submodules/api_middleware';
import { getAddress } from 'services/member.service';

export const useExistingAddress = (
    load = true,
    reload = false
): AddressApiInterface | false => {
    const [address, setAddress] = useState<AddressApiInterface | false>(false);

    useEffect(() => {
        if (load && (address === false || reload)) {
            getAddress().then((response) => {
                setAddress(response);
            });
        } else {
            setAddress(false);
        }
    }, [load, reload]);

    return address;
};
